import { ENV } from "../../../../utils";

export function getCategoriesResponse(result) {
  const categories = result?.categories || result?.response || result;

  return Array.isArray(categories) ? categories : [];
}

export function getSettingsResponse(result) {
  const settings = result?.settings || result?.response || result || {};

  return {
    heroBannerPath: settings?.heroBanner?.path || "",
  };
}

export function getProductsResponse(result) {
  const response = result?.products || result?.response || result || {};

  return Array.isArray(response.docs) ? response.docs : [];
}

export function shuffleArray(list) {
  const array = [...list];

  for (let i = array.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }

  return array;
}

export function pickRandomProducts(list, count) {
  return shuffleArray(list).slice(0, count);
}

export function getImageUrl(imagePath) {
  if (!imagePath) {
    return "";
  }

  const value = String(imagePath);

  if (
    value.startsWith("http://") ||
    value.startsWith("https://") ||
    value.startsWith("blob:")
  ) {
    return value;
  }

  return `${ENV.SERVER_HOST}/${value.replace(/\\/g, "/").replace(/^\/+/, "")}`;
}
